import React from 'react';
import ReactDOM from 'react-dom/client';
import { MsalProvider } from '@azure/msal-react';
import { Provider } from 'react-redux';
import { persistor, store } from './store';
import { PersistGate } from 'redux-persist/integration/react';
import { aadConfig } from 'config';
import { PublicClientApplication, EventType } from '@azure/msal-browser';
import { ToastContainer } from 'react-toastify';
import 'react-toastify/dist/ReactToastify.css';
import 'remixicon/fonts/remixicon.css';
import App from './App';

const pca = new PublicClientApplication(aadConfig);

(window as any).__MSAL_INSTANCE__ = pca;

pca.initialize().then(() => {
  pca.handleRedirectPromise().catch((error) => {
    console.error('Redirect error:', error);
  });

  const accounts = pca.getAllAccounts();
  if (accounts.length > 0) {
    pca.setActiveAccount(accounts[0]);
  }

  pca.addEventCallback((event: any) => {
    if (event.eventType === EventType.LOGIN_SUCCESS && event.payload.account) {
      const account = event.payload.account;
      pca.setActiveAccount(account);
    }
  });

  const root = ReactDOM.createRoot(
    document.getElementById('root') as HTMLElement
  );
  root.render(
    <React.StrictMode>
      <MsalProvider instance={pca}>
        <Provider store={store}>
          <PersistGate loading={<div>Loading..</div>} persistor={persistor}>
            <App />
            <ToastContainer
              position="top-right"
              autoClose={3000}
              hideProgressBar
              newestOnTop={false}
              closeOnClick
              rtl={false}
              pauseOnFocusLoss
              draggable
              pauseOnHover
              theme="light"
            />
          </PersistGate>
        </Provider>
      </MsalProvider>
    </React.StrictMode>
  );
});
